import thunk from "redux-thunk";
import { createStore, applyMiddleware, compose } from "redux";
import RootReducer from "./RootReducer";

const initialState = {};
let devtools = (x) => x;

if (
  process.env.NODE_ENV !== "production" &&
  process.browser &&
  window.__REDUX_DEVTOOLS_EXTENSION__
) {
  devtools = window.__REDUX_DEVTOOLS_EXTENSION__();
}

const index = () => {
  let store = createStore(
    RootReducer,
    initialState,
    compose(applyMiddleware(thunk), devtools)
  );

  store.subscribe(() => {});

  return { store };
};
export default index;
